WiseMetering.Collection.Packages = WiseMetering.Collection.extend({
    model: WiseMetering.Model.Package
});
